<template>
  <div>
    <div
      class="
        secondary--text
        text--darken-1 text-h5 text-sm-h4 text-md-h3 text-lg-h2
        font-weight-bold
        text-center
      "
    >
      <slot />

      <img
        :src="`/img/title-${mod}.png`"
        :height="logoHeight"
        width="auto"
        class="d-flex mt-2 mx-auto"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mod: {
      type: String,
      required: true,
    },
    logoHeight: {
      type: String,
      default: "35px",
    },
  },
};
</script>
